import { render, staticRenderFns } from "./RsaGestionePazientiAdiProgrammatiComponent.vue?vue&type=template&id=48c8ba05"
import script from "./RsaGestionePazientiAdiProgrammatiComponent.vue?vue&type=script&lang=js"
export * from "./RsaGestionePazientiAdiProgrammatiComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaGestionePazientiAdiProgrammatiComponent.vue?vue&type=style&index=0&id=48c8ba05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports